import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-[90%] my-3 mx-auto flex flex-wrap text-left items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl pt-4 drop-shadow titleFont text-center w-full mb-3" }, "HURRY, now free ⏱️", -1)
const _hoisted_3 = { class: "appFont text-lg text-gray-400" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "appFont text-sm my-2" }, " Tip: You should wait before answering, because if you run out of points because of a wrong answer, it will take some time before you can answer again 😦 ", -1)
const _hoisted_5 = { class: "my-3 bg-gray-200 dark:bg-gray-800 px-3 py-2 rounded-lg w-full appFont inline-flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Your current points:", -1)
const _hoisted_7 = { class: "ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heart = _resolveComponent("Heart")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Sheet = _resolveComponent("Sheet")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_Sheet, {
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    visibility: _ctx.showSheet
  }, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(" Why is it good to answer? Each "),
          _withDirectives(_createVNode(_component_Heart, { class: "text-red-500 cursor-pointer" }, null, 512), [
            [_directive_tippy, {content: 'heart ❤️'}]
          ]),
          _createTextVNode(" you get for your answer is worth 2 points, which is multiplied by your point multiplier 🤩 ")
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$aveta(4255)), 1)
        ]),
        _createVNode(_component_Button, { class: "my-4" }, {
          default: _withCtx(() => [
            _createTextVNode(" Answer for 100 points ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visibility"]))
}